const LOCK_PREFIX = "vt_login_lock:";
const LEGACY_RESULT_PREFIX = "vt_login_result:";

function normalizeEmail(payload) {
    let body = payload;

    if (typeof payload === "string") {
        try {
            body = JSON.parse(payload);
        } catch {
            body = {};
        }
    }

    return (
        String(body?.email_id ?? "")
            .trim()
            .toLowerCase() || "__unknown__"
    );
}

function readResult(email) {
    try {
        const raw = localStorage.getItem(LOCK_PREFIX + email);
        return raw ? JSON.parse(raw).response : null;
    } catch {
        return null;
    }
}

function saveResult(email, response) {
    try {
        localStorage.setItem(LOCK_PREFIX + email, JSON.stringify({ response }));
    } catch (error) {
        console.warn("[login-coord] could not save result", error);
    }
}

export function clearLoginResults() {
    try {
        Object.keys(localStorage)
            .filter(
                (key) =>
                    key.startsWith(LOCK_PREFIX) ||
                    key.startsWith(LEGACY_RESULT_PREFIX),
            )
            .forEach((key) => localStorage.removeItem(key));
    } catch {
        // Ignore storage errors.
    }
}

export async function coordinatedLoginRequest(axios, requestConfig) {
    const email = normalizeEmail(requestConfig.data);

    if (typeof navigator === "undefined" || !navigator.locks) {
        return axios.request(requestConfig);
    }

    return navigator.locks.request(LOCK_PREFIX + email, async () => {
        const cached = readResult(email);
        if (cached) return cached;

        const res = await axios.request(requestConfig);
        const response = { data: res.data, status: res.status };

        saveResult(email, response);
        return response;
    });
}
